import { useState, useEffect } from 'react';

export const useFavorites = () => {
  const [favorites, setFavorites] = useState([]);
  const [watchlist, setWatchlist] = useState([]);

  // Load favorites and watchlist from localStorage on mount
  useEffect(() => {
    const savedFavorites = localStorage.getItem('movieFavorites');
    const savedWatchlist = localStorage.getItem('movieWatchlist');

    if (savedFavorites) {
      try {
        setFavorites(JSON.parse(savedFavorites));
      } catch (error) {
        console.error('Error parsing favorites from localStorage:', error);
        setFavorites([]);
      }
    }

    if (savedWatchlist) {
      try {
        setWatchlist(JSON.parse(savedWatchlist));
      } catch (error) {
        console.error('Error parsing watchlist from localStorage:', error);
        setWatchlist([]);
      }
    }
  }, []);

  // Save favorites to localStorage whenever favorites change
  useEffect(() => {
    localStorage.setItem('movieFavorites', JSON.stringify(favorites));
  }, [favorites]);

  // Save watchlist to localStorage whenever watchlist changes
  useEffect(() => {
    localStorage.setItem('movieWatchlist', JSON.stringify(watchlist));
  }, [watchlist]);

  // Toggle favorite status
  const toggleFavorite = (movie) => {
    setFavorites(prev => {
      const isFavorite = prev.some(fav => fav.id === movie.id);
      if (isFavorite) {
        return prev.filter(fav => fav.id !== movie.id);
      } else {
        return [...prev, movie];
      }
    });
  };

  // Toggle watchlist status
  const toggleWatchlist = (movie) => {
    setWatchlist(prev => {
      const isInWatchlist = prev.some(item => item.id === movie.id);
      if (isInWatchlist) {
        return prev.filter(item => item.id !== movie.id);
      } else {
        return [...prev, movie];
      }
    });
  };

  // Check if a movie is in favorites
  const isFavorite = (movieId) => {
    return favorites.some(fav => fav.id === movieId);
  };

  // Check if a movie is in watchlist
  const isInWatchlist = (movieId) => {
    return watchlist.some(item => item.id === movieId);
  };

  // Remove movie from favorites
  const removeFavorite = (movieId) => {
    setFavorites(prev => prev.filter(fav => fav.id !== movieId));
  };

  // Remove movie from watchlist
  const removeFromWatchlist = (movieId) => {
    setWatchlist(prev => prev.filter(item => item.id !== movieId));
  };

  // Clear all favorites
  const clearFavorites = () => {
    setFavorites([]);
  };

  // Clear all watchlist
  const clearWatchlist = () => {
    setWatchlist([]);
  };

  return {
    favorites,
    watchlist,
    toggleFavorite,
    toggleWatchlist,
    isFavorite,
    isInWatchlist,
    removeFavorite,
    removeFromWatchlist,
    clearFavorites,
    clearWatchlist,
  };
};
